import React, { useState } from 'react';
import { Select, Tooltip, Empty, Popover, Tag, Card, Timeline } from 'antd';
import { useMappedState } from 'redux-react-hook';
import moment from 'moment';
import { s3, EVENT_TYPE, EVENT_TYPE_COLOR } from './../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'
import { faUserTie } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { faInbox } from '@fortawesome/free-solid-svg-icons'
import CustomAvatar from './../components/customAvatar';
import EventBodyDisplay from './../components/eventBodyDisplay';
import EventTypeIcon from './eventTypeIcon';
import { navigate } from "@reach/router"
import { flexCenterRight } from './../theme';
import { renderBottom } from './../utils/helper';

const { groupBy, sortBy, uniqBy } = require('lodash');
const uuidv1 = require('uuid/v1');

function EventsList(props) {
  let data = props.data;
  const session = useMappedState(state => state.session);
  const [userId, setuserId] = useState('All');

  let users = props.data.map((i) => {return i.user_docs});
  users = uniqBy(users, 'id').map((i) => {
    return {
      id: i.id,
      name: `${i.firstname} ${i.lastname}`,
      firstname: i.firstname,
      lastname: i.lastname,
    }
  });
  users = [...[{id: 'All', name: 'All'}], ...users];

  if (userId !== 'All') {
    data = props.data.filter((i) => i.user_docs.id === userId);
  }

  data = sortBy(data, 'createdAt').reverse().map(i => {
    return {
      ...i,
      ...{date: `${moment(i.createdAt).format('DD-MM-YYYY')}, ${moment(i.createdAt).format('dddd')}`}
    }
  });

  const groupedData = groupBy(data, 'date');

  const dataArr = Object.keys(groupedData).map(e => {
    return {
      date: e,
      events: groupedData[e]
    }
  });

  let events = [];
  for (const item of dataArr) {
    events.push({id: uuidv1(), dateWithName: item.date});
    for (const event of sortBy(item.events, 'createdAt').reverse()) {
      const userAvatarUrl = `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${event.user_docs.id}.jpeg`;
      const newUser = {...event.user_docs, ...{userAvatarUrl}};

      let newContact = event.contact_docs;

      if (event.contact_docs) {
        const contactAvatarUrl = `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${event.contact_docs.id}.jpeg`;
        newContact = {...event.contact_docs, ...{contactAvatarUrl}};
      }

      let newCandidate = event.candidate_docs;

      if (event.candidate_docs) {
        const candidateAvatarUrl = `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${event.candidate_docs.id}.jpeg`;
        newCandidate = {...event.candidate_docs, ...{candidateAvatarUrl}};
      }

      events.push({...event, ...{user: newUser}, ...{contact: newContact}, ...{candidate: newCandidate}})
    }
  }

  const eventCardExtra = (i) => {
    return(
      <CustomAvatar
        showTooltip={true}
        tooltipTitle={i.user.id === session.id ? "Me" : `${i.user.firstname} ${i.user.lastname}`}
        colourCode={i.user.firstname.charAt(0).toLowerCase()}
        char={`${i.user.firstname.charAt(0).toUpperCase()}${i.user.lastname.charAt(0).toUpperCase()}`}
        charSize={12}
        size={30}
        src={i.user.userAvatarUrl}
      />
    )
  }

  const contactTitle = (i) => {
    return(
      <span>
      <CustomAvatar
        colourCode={i.contact.firstname.charAt(0).toLowerCase()}
        char={`${i.contact.firstname.charAt(0).toUpperCase()}${i.contact.lastname.charAt(0).toUpperCase()}`}
        charSize={12}
        size={30}
        src={i.contact.contactAvatarUrl}
      />
        &nbsp;&nbsp;<span style={{fontWeight: 'normal'}}>{i.contact.firstname} {i.contact.lastname}</span>
      </span>
    )
  }

  const popoverContact = (i) => {
    return(
      <div>
        <div style={{marginBottom: '5px'}}>
        <Tag color="purple">Contact</Tag>
        </div>
        {
          !i.contact.dob && !i.contact.department && !i.contact.position ?
          <i style={{color: '#cccccc'}}>No Information Available</i>
          :
          null
        }

        {
          i.contact.dob?
          <><FontAwesomeIcon icon={faBirthdayCake} />&nbsp;<b>Birthday</b>: {moment(i.contact.dob).format('DD-MM-YYYY')}<br/></>
          :
          null
        }
        {
          i.contact.department?
          <><FontAwesomeIcon icon={faBuilding} />&nbsp;<b>Department</b>: {i.contact.department}<br/></>
          :
          null
        }
        {
          i.contact.position?
          <><FontAwesomeIcon icon={faUserTie} />&nbsp;<b>Position</b>: {i.contact.position}</>
          :
          null
        }
      </div>
    )
  }

  const candidateTitle = (i) => {
    return(
      <span>
      <CustomAvatar
        colourCode={i.candidate.firstname.charAt(0).toLowerCase()}
        char={`${i.candidate.firstname.charAt(0).toUpperCase()}${i.candidate.lastname.charAt(0).toUpperCase()}`}
        charSize={12}
        size={30}
        src={i.candidate.candidateAvatarUrl}
      />
        &nbsp;&nbsp;<span style={{fontWeight: 'normal'}}>{i.candidate.firstname} {i.candidate.lastname}</span>
      </span>
    )
  }

  const popoverCandidate = (i) => {
    return(
      <div>
         <div style={{marginBottom: '5px'}}>
         <Tag color="green">Candidate</Tag>
         </div>

         {
           !i.candidate.dob && !i.candidate.service && !i.candidate.position ?
           <i style={{color: '#cccccc'}}>No Information Available</i>
           :
           null
         }

        {
          i.candidate.dob?
          <><FontAwesomeIcon icon={faBirthdayCake} />&nbsp;<b>Birthday</b>: {moment(i.candidate.dob).format('DD-MM-YYYY')}<br/></>
          :
          null
        }
        {
          i.candidate.service?
          <><FontAwesomeIcon icon={faBriefcase} />&nbsp;<b>Service</b>: {i.candidate.service}<br/></>
          :
          null
        }
        {
          i.candidate.position?
          <><FontAwesomeIcon icon={faUserTie} />&nbsp;<b>Position</b>: {i.candidate.position}</>
          :
          null
        }
      </div>
    )
  }

  const eventCardTitle = (i) => {
    return(
      <div>
        {
          i.isEmail ?
          <span>
            <Tooltip title={`email ${i.emailType}`}>
            <FontAwesomeIcon 
              style={{cursor: 'pointer', color: '#B0BF1A'}} 
              icon={i.emailType === 'sent' ? faPaperPlane : faInbox} />&nbsp;
            </Tooltip>
          </span>
          :
          null
        }
         <EventTypeIcon event={i} />
         &nbsp;&nbsp;

        <Tag color={EVENT_TYPE_COLOR[i.type]}>{EVENT_TYPE[i.type].text}</Tag>

        {
          i.type === 'vacancy' ? 
          <span>{i.title}</span>
          : null
        }
        
        {
          i.contact ?
          <React.Fragment>
          &nbsp;&nbsp;&nbsp;
          <Popover placement="right" content={popoverContact(i)} title={contactTitle(i)}>
          <span style={{cursor: 'pointer'}} onClick={() => {
            navigate(`/contacts/${i.contact.id}`)
          }}
          >{contactTitle(i)}</span>
          </Popover>
          &nbsp;&nbsp;<Tag style={{cursor: 'pointer'}} onClick={() => {
            navigate(`/clients/${i.client_docs.id}`)
          }}>{i.client_docs.name}</Tag>
          </React.Fragment>
          :
          null
        }

        {
          i.candidate ?
          <React.Fragment>
          &nbsp;&nbsp;&nbsp;
          <Popover placement="right" content={popoverCandidate(i)} title={candidateTitle(i)}>
          <span style={{cursor: 'pointer'}} onClick={() => {
            navigate(`/candidates/${i.candidate.id}`)
          }}
          >{candidateTitle(i)}</span>
          </Popover>
          </React.Fragment>
          :
          null
        }

      </div>
    )
  }

  const eventCard = (i) => {
    return(
      <div style={{marginLeft: "25px", marginBottom: "25px"}}>
        <Card
          size="small"
          title={eventCardTitle(i)}
          extra={eventCardExtra(i)}
        >
        {i.body === "" ? 
          <span style={{color: '#ddd'}}>Empty body</span> 
          : 
          <EventBodyDisplay data={i.body}/>
        }
        {renderBottom(i)}
        </Card>
      </div>
    )
  }

  const renderEventRow = (i) => {
    if (!i.type) {
      return(
        <Timeline.Item
          key={i.id}
          dot={<FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: '20px' }} />}
          color="blue"
        >
        <b>{i.dateWithName}</b>
        </Timeline.Item>
      )
    }
    return(
      <Timeline.Item
        key={i.id}
        dot={moment(i.createdAt).format("HH:mm")}
      >
       {eventCard(i)}
      </Timeline.Item>
    )
  }

  return (
    events.length > 0 ?
    <div style={{marginTop: '15px', marginLeft: '15px', marginRight: '5px'}}>
      <div style={flexCenterRight}>
        <Select
          style={{width: '200px'}}
          showSearch
          optionFilterProp="label"
          defaultValue={users[0].name}
          onChange={(value) => {
            setuserId(value);
          }}
        >
          {users.map((i) => (
            <Select.Option
              label={i.name}
              key={i.id}
              value={i.id}
            >
              {
                i.id !== 'All' ? (
                  <>
                    <CustomAvatar
                      style={{marginTop: '-3px'}}
                      colourCode={i.firstname.charAt(0).toLowerCase()}
                      char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                      charSize={11}
                      size={26}
                      src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${i.id}.jpeg`}
                    />
                    &nbsp;&nbsp;{i.name}
                  </>
                ) : <>{i.name}</>
              }
            </Select.Option>
          ))}
        </Select>
      </div>
      <br/>
      <Timeline>
      {
        events.map(i => {
          return renderEventRow(i)
        })
      }
      </Timeline>
    </div>
    :
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  );
}

export default EventsList;
